/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_EveryoneInputs */

const en_landing_calendar_everyone = /** @type {(inputs: Landing_Calendar_EveryoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone`)
};

const pl_landing_calendar_everyone = /** @type {(inputs: Landing_Calendar_EveryoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszyscy`)
};

/**
* | output |
* | --- |
* | "Everyone" |
*
* @param {Landing_Calendar_EveryoneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_everyone = /** @type {((inputs?: Landing_Calendar_EveryoneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_EveryoneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_everyone(inputs)
	return en_landing_calendar_everyone(inputs)
});